import { httpservice } from '../services';
import { constants } from '../constant/constant';

const verify2FAToken = (data) => httpservice()
  .post(constants.API.VERIFY_2FA_TOKEN, data)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export default verify2FAToken;
